// RevivalHeader — the one-row header every Revival screen shares: title · tabular
// totals · plain actions · ⋯ · at most one primary (the screen's one accent fill).
import React, { useEffect, useRef, useState } from "react";
import { MoreHorizontal } from "lucide-react";
import Button from "../ui/button";
import "../ui/ds.css";
import "./revival.css";

export default function RevivalHeader({ title, totals = [], actions = null, primary = null, menu = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const items = menu.filter(Boolean);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);
  const shown = totals.filter(Boolean);
  return (
    <header className="rv-head">
      <h1>{title}</h1>
      {shown.length ? (
        <div className="rv-head-totals" aria-label="Totals">
          {shown.map((t, i) => (
            <React.Fragment key={i}>
              {i ? <span aria-hidden="true">·</span> : null}
              <span>{t}</span>
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <div className="rv-head-actions">
        {actions}
        {items.length ? (
          <div className="ds-menu" ref={ref}>
            <Button variant="ghost" size="sm" iconOnly aria-label="More actions" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
              <MoreHorizontal size={16} />
            </Button>
            {open ? (
              <div className="ds-menu__list" role="menu">
                {items.map((item) => (
                  <button key={item.label} type="button" role="menuitem" className="ds-menu__item" disabled={item.disabled}
                    onClick={() => { setOpen(false); item.onClick?.(); }}>
                    {item.label}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
        {primary}
      </div>
    </header>
  );
}

export function StatStrip({ stats }) {
  return (
    <div className="rv-stats" style={{ "--rv-cols": stats.length }}>
      {stats.map((s) => (
        <div key={s.label} className="rv-stat">
          <span>{s.label}</span>
          <b>{s.value}</b>
          {s.note ? <small>{s.note}</small> : null}
        </div>
      ))}
    </div>
  );
}
